import classnames from 'classnames';

import * as styles from '../Recommendations.css';

interface Props {
  text: string;
  className?: string;
}

const Sponsored = ({ text = 'Sponsored', className }: Props) => {
  return <span className={classnames(className, styles.sponsoredText)}>{text}</span>;
};

export default Sponsored;
